// src/slices/profile/thunk.js
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

// ================= GET ALL =================
export const getAllProfiles = createAsyncThunk("profile/getAll", async (categoryId, thunkAPI) => {
  try {
    const res = await axios.get(`${API_URL}/profile/all`, { params: categoryId ? { categoryId } : {} });

    return res.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response?.data);
  }
});
// ================= GET BY ID =================
export const getProfileById = createAsyncThunk("profile/getById", async (id, thunkAPI) => {
  try {
    const res = await axios.get(`${API_URL}/profile/all`, { params: { identifier: id } });

    return res.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response?.data);
  }
});

// ================= GET BY SLUG =================
export const getProfileBySlug = createAsyncThunk("profile/getBySlug", async (slug, thunkAPI) => {
  try {
    const res = await axios.get(`${API_URL}/profile/one`, { params: { identifier: slug } });

    return res.data?.data;
  } catch (err) {
    return thunkAPI.rejectWithValue(err.response?.data);
  }
});
